import TwicPics from '@twicpics/components/vue2'
import Vue from 'vue'

import '@twicpics/components/style.css'

Vue.use(TwicPics, {
  domain: 'https://japhy-assets.twic.pics',
})
